// 本地
module.exports = {
  // 2.0
  baseUrl: 'http://127.0.0.1:2004', // 收银台正式项目地址
  baseApi: 'http://127.0.0.1:2001', // 正式api请求地址
};
